import updateCartViews from "../carts/eCommerce";

export default class QuickCart extends HTMLButtonElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.bindEvents();
    }

    bindEvents(){
        $(this).on("click", (e) => {
            e.preventDefault();
            e.stopImmediatePropagation();
            this.addToCart(this);            
        });

        const quantityContainer = $(this).prev();

        if (quantityContainer.length) {
            $('button.quantity-down', quantityContainer).on("click", (e) => {
                e.preventDefault();
                e.stopImmediatePropagation();
                let quantity = parseInt($('input[name="product-count"]', quantityContainer).val());

                if (quantity > 1) {
                    quantity--;
                } else {
                    quantity = 1;
                }

                $('input[name="product-count"]', quantityContainer).val(quantity);
            });

            $('button.quantity-up', quantityContainer).on("click", (e) => {
                e.preventDefault();
                e.stopImmediatePropagation();
                let quantity = parseInt($('input[name="product-count"]', quantityContainer).val()) + 1;

                $('input[name="product-count"]', quantityContainer).val(quantity);
            });
        }
    }

    addToCart( e ) {
        let quantity = 1;

        if ($(this).prev().length) {
            quantity = $('input[name="product-count"]', $(this).prev()).val();
        }

        HegydCore.sendRequest( $(e).data('url'),'PUT', {
            'cart_id': $(this).data('cart'),
            'product_id': $(this).data('product'),
            'quantity': quantity,
            'return_templates': this.getAllCartTemplate(),
        }, ( data ) => {
            this.updateCartViews(data);
            this.connectedCallback();
            $(".sv2").removeClass("show");
            toastr.success( data.message );
            $('#reload_btn').trigger('click');
        })
    }

    getAllCartTemplate () {
        return ['cart_weight','cart_right', 'cart_lines_list'];
    }

    // reloadCart() {
    //     HegydCore.sendRequest( $('#cart_header').data('route_refresh'), 'GET', {
    //         'return_templates': this.getAllCartTemplate(),
    //     }, data => {
    //         this.updateCartViews(data);
    //     });
    // }

    updateCartViews( data ) {
        updateCartViews(data);
    }
}
